export const initialState = {
    projects: [],
    project: {
        archived: false,
        assets: [],
        clients: [],
        connections: [],
        name: '',
        lastmodified: 0,
        projectdetails: null,
        projectdetailsimage: null,
        projectid: null,
        projectuserid: null,
        readings: [],
        widgets: [],
        size: '',
        structure: [],
        users: []
    },
}

const reducer = (state, action) => {
    switch (action.type) {
        case "ADD_USERNAME":
            return {
                ...state,
                user: {
                    ...state.user,
                    username: action.username
                }
            };
        case "SET_PROJECTS":
            return {
                ...state,
                projects: action.projects
            }
        case "SET_PROJECT":
            return {
                ...state,
                project: action.project
            }
        case "UNSET_PROJECT":
            return {
                ...state,
                project: initialState.project
            }
        case "ADD_PROJECT":
            return {
                ...state,
                projects: [...state.projects, action.project],
            };
        case "UPDATE_PROJECT":
            return {
                ...state,
                projects: state.projects.map((project) => project.id === action.project.projectid ? action.project : project
                ),
            };
        case "REMOVE_PROJECT":
            return {
                ...state,
                projects: state.projects.filter((project) => project.id !== action.projectid),
            };
        case "ADD_ANNOUNCEMENT":
            return {
                ...state,
                project: {
                    ...state.project,
                    announcements: [...state.project.announcements, action.announcement]
                }
            };
        case "UPDATE_ANNOUNCEMENT":
            return {
                ...state,
                project: {
                    ...state.project,
                    announcements: state.project.announcements.map(announcement =>
                        announcement.id === action.announcement.id ? action.announcement : announcement
                    )
                }
            };
        case "REMOVE_ANNOUNCEMENT":
            return {
                ...state,
                project: {
                    ...state.project,
                    announcements: state.project.announcements.filter(announcement => announcement.id !== action.announcementid)
                }
            };
        case "ADD_ACCESSCONTROL":
            return {
                ...state,
                project: {
                    ...state.project,
                    accesscontrols: [...state.project.accesscontrols, action.accesscontrol]
                }
            };
        case "UPDATE_ACCESSCONTROL":
            return {
                ...state,
                project: {
                    ...state.project,
                    accesscontrols: state.project.accesscontrols.map(ac =>
                        ac.id === action.accesscontrol.id ? action.accesscontrol : ac
                    )
                }
            };
        case "REMOVE_ACCESSCONTROL":
            return {
                ...state,
                project: {
                    ...state.project,
                    accesscontrols: state.project.accesscontrols.filter(acc => acc.id !== action.accesscontrolid)
                }
            };
        case "ADD_ASSETS":
            return {
                ...state,
                project: {
                    ...state.project,
                    assets: action.assets
                }
            };
        case "ADD_ASSET":
            return {
                ...state,
                project: {
                    ...state.project,
                    assets: [...state.project.assets, action.asset]
                }
            };
        case "UPDATE_ASSET":
            return {
                ...state,
                project: {
                    ...state.project,
                    assets: state.project.assets.map(asset =>
                        asset.id === action.asset.id ? action.asset : asset
                    )
                }
            };
        case "REMOVE_ASSET":
            return {
                ...state,
                project: {
                    ...state.project,
                    assets: state.project.assets.filter(asset => asset.id !== action.assetid)
                }
            };
        case "ADD_CONNECTIONS":
            return {
                ...state,
                project: {
                    ...state.project,
                    connections: action.connections
                }
            };
        case "ADD_STRUCTURE":
            return {
                ...state,
                project: {
                    ...state.project,
                    structure: action.structure
                }
            };
        case "ADD_ELEMENT":
            return {
                ...state,
                project: {
                    ...state.project,
                    structure: [...state.project.structure, action.element]
                }
            };
        case "UPDATE_ELEMENT":
            return {
                ...state,
                project: {
                    ...state.project,
                    structure: state.project.structure.map(el =>
                        el.id === action.element.id ? action.element : el
                    )
                }
            };
        case "REMOVE_ELEMENT":
            return {
                ...state,
                project: {
                    ...state.project,
                    structure: state.project.structure.filter(el => el.id !== action.elementid)
                }
            };
        case "ADD_CLIENT":
            return {
                ...state,
                project: {
                    ...state.project,
                    clients: [...state.project.clients, action.client]
                }
            };
        case "UPDATE_CLIENT":
            return {
                ...state,
                project: {
                    ...state.project,
                    clients: state.project.clients.map(client =>
                        client.id === action.client.id ? action.client : client
                    )
                }
            };
        case "REMOVE_CLIENT":
            return {
                ...state,
                project: {
                    ...state.project,
                    clients: state.project.clients.filter(client => client.id !== action.id)
                }
            };
        case "ADD_WIDGET":
            return {
                ...state,
                project: {
                    ...state.project,
                    widgets: [...state.project.widgets, action.widget]
                }
            };
        case "UPDATE_WIDGET":
            return {
                ...state,
                project: {
                    ...state.project,
                    widgets: state.project.widgets.map(widget =>
                        widget.id === action.widget.id ? action.widget : widget
                    )
                }
            };
        case "REMOVE_WIDGET":
            return {
                ...state,
                project: {
                    ...state.project,
                    widgets: state.project.widgets.filter(widget => widget.id !== action.widgetid)
                }
            };
        case "UPDATE_PROJECTKEYS":
            const updatedState = { ...state.project };
            action.keys.forEach(key => {
                updatedState[key] = action.data[key];
            });
            return {
                ...state,
                project: updatedState
            };
        case "ADD_PROJECTDETAILS":
            return {
                ...state,
                project: {
                    ...state.project,
                    projectdetails: action.projectdetails,
                    projectdetailsimage: action.projectdetailsimage
                }
            };
        case "REMOVE_PROJECTDETAILSIMAGE":
            return {
                ...state,
                project: {
                    ...state.project,
                    projectdetailsimage: ''
                }
            };
        case "ADD_STARTDATE":
            return {
                ...state,
                project: {
                    ...state.project,
                    startdate: action.startdate
                }
            };
        case "ADD_PURCHASEINVOICE":
            return {
                ...state,
                project: {
                    ...state.project,
                    purchaseinvoices: [...state.project.purchaseinvoices, action.purchaseinvoice]
                }
            };
        case "UPDATE_PURCHASEINVOICE":
            return {
                ...state,
                project: {
                    ...state.project,
                    purchaseinvoices: state.project.purchaseinvoices.map(invoice =>
                        invoice.id === action.purchaseinvoice.id ? action.purchaseinvoice : invoice
                    )
                }
            };
        case "REMOVE_PURCHASEINVOICE":
            return {
                ...state,
                project: {
                    ...state.project,
                    purchaseinvoices: state.project.purchaseinvoices.filter(invoice => invoice.id !== action.purchaseinvoiceid)
                }
            };
        case "REMOVE_PURCHASEINVOICES":
            return {
                ...state,
                project: {
                    ...state.project,
                    purchaseinvoices: state.project.purchaseinvoices.filter(invoice => invoice.id !== action.id)
                }
            };
        case "ADD_READINGS":
            return {
                ...state,
                project: {
                    ...state.project,
                    readings: action.readings
                }
            };
        case "ADD_READING":
            return {
                ...state,
                project: {
                    ...state.project,
                    readings: [...state.project.readings, action.reading]
                }
            };
        case "UPDATE_READING":
            return {
                ...state,
                project: {
                    ...state.project,
                    readings: state.project.readings.map(reading =>
                        reading.id === action.reading.id ? action.reading : reading
                    )
                }
            };
        case "REMOVE_READING":
            return {
                ...state,
                project: {
                    ...state.project,
                    readings: state.project.readings.filter(reading => reading.id !== action.readingid)
                }
            };
        case "ADD_METER":
            return {
                ...state,
                project: {
                    ...state.project,
                    meters: [...state.project.meters, action.meter]
                }
            };
        case "UPDATE_METER":
            return {
                ...state,
                project: {
                    ...state.project,
                    meters: state.project.meters.map(meter =>
                        meter.id === action.meter.id ? action.meter : meter
                    )
                }
            };
        case "REMOVE_METER":
            return {
                ...state,
                project: {
                    ...state.project,
                    meters: state.project.meters.filter(meter => meter.id !== action.meterid)
                }
            };
        case "ADD_RECONCILIATION":
            return {
                ...state,
                project: {
                    ...state.project,
                    reconciliations: [...state.project.reconciliations, action.reconciliation]
                }
            };
        case "UPDATE_RECONCILIATION":
            return {
                ...state,
                project: {
                    ...state.project,
                    reconciliations: state.project.reconciliations.map(reconciliation =>
                        reconciliation.id === action.reconciliation.id ? action.reconciliation : reconciliation
                    )
                }
            };
        case "REMOVE_RECONCILIATION":
            return {
                ...state,
                project: {
                    ...state.project,
                    reconciliations: state.project.reconciliations.filter(reconciliation => reconciliation.id !== action.reconciliationid)
                }
            };
        case "ADD_SUBACCOUNT":
            return {
                ...state,
                project: {
                    ...state.project,
                    subaccounts: [...state.project.subaccounts, action.subaccount]
                }
            };
        case "UPDATE_SUBACCOUNT":
            return {
                ...state,
                project: {
                    ...state.project,
                    subaccounts: state.project.subaccounts.map(subaccount =>
                        subaccount.id === action.subaccount.id ? action.subaccount : subaccount
                    )
                }
            };
        case "REMOVE_SUBACCOUNT":
            return {
                ...state,
                project: {
                    ...state.project,
                    subaccounts: state.project.subaccounts.filter(subaccount => subaccount.id !== action.subaccountid)
                }
            };
        case "ADD_SUPPLIER":
            return {
                ...state,
                project: {
                    ...state.project,
                    suppliers: [...state.project.suppliers, action.supplier]
                }
            };
        case "UPDATE_SUPPLIER":
            return {
                ...state,
                project: {
                    ...state.project,
                    suppliers: state.project.suppliers.map(supplier =>
                        supplier.id === action.supplier.id ? action.supplier : supplier
                    )
                }
            };
        case "REMOVE_SUPPLIER":
            return {
                ...state,
                project: {
                    ...state.project,
                    suppliers: state.project.suppliers.filter(supplier => supplier.id !== action.supplierid)
                }
            };
        case "ADD_TASK":
            return {
                ...state,
                project: {
                    ...state.project,
                    tasks: [...state.project.tasks, action.task]
                }
            };
        case "UPDATE_TASK":
            return {
                ...state,
                project: {
                    ...state.project,
                    tasks: state.project.tasks.map(task =>
                        task.id === action.task.id ? action.task : task
                    )
                }
            };
        case "REMOVE_TASK":
            return {
                ...state,
                project: {
                    ...state.project,
                    tasks: state.project.tasks.filter(task => task.id !== action.taskid)
                }
            };
        case "ADD_TRANSACTION":
            return {
                ...state,
                project: {
                    ...state.project,
                    transactions: [...state.project.transactions, action.transaction]
                }
            };
        case "UPDATE_TRANSACTION":
            return {
                ...state,
                project: {
                    ...state.project,
                    transactions: state.project.transactions.map(transaction =>
                        transaction.id === action.transaction.id ? action.transaction : transaction
                    )
                }
            };
        case "REMOVE_TRANSACTION":
            return {
                ...state,
                project: {
                    ...state.project,
                    transactions: state.project.transactions.filter(transaction => transaction.id !== action.id)
                }
            };
        case "REMOVE_TRANSACTIONS":
            return {
                ...state,
                project: {
                    ...state.project,
                    transactions: state.project.transactions.filter(transaction =>
                        !action.ids.includes(transaction.id)
                    )
                }
            };
        case "ADD_USER":
            return {
                ...state,
                project: {
                    ...state.project,
                    users: [...state.project.users, action.user]
                }
            };
        case "UPDATE_USER":
            return {
                ...state,
                project: {
                    ...state.project,
                    users: state.project.users.map(user =>
                        user.id === action.user.id ? action.user : user
                    )
                }
            };
        case "REMOVE_USER":
            return {
                ...state,
                project: {
                    ...state.project,
                    users: state.project.users.filter(user => user.id !== action.userid)
                }
            };
        case "IMPORT_JOURNALENTRIES":
            return {
                ...state,
                project: {
                    ...state.project,
                    journalentries: [...state.project.journalentries, ...action.journalentries]
                }
            };
        case "IMPORT_PURCHASEINVOICES":
            return {
                ...state,
                project: {
                    ...state.project,
                    purchaseinvoices: [...state.project.purchaseinvoices, ...action.purchaseinvoices]
                }
            };
        case "IMPORT_INTERACCOUNTTRANSFERS":
            return {
                ...state,
                project: {
                    ...state.project,
                    interaccounttransfers: [...state.project.interaccounttransfers, ...action.interaccounttransfers]
                }
            };
        case "IMPORT_TRANSACTIONS":
            return {
                ...state,
                project: {
                    ...state.project,
                    transactions: [...state.project.transactions, ...action.transactions]
                }
            };
        case "IMPORT_CLIENTS":
            return {
                ...state,
                project: {
                    ...state.project,
                    clients: [...state.project.clients, ...action.clients]
                }
            };
        case "IMPORT_SUPPLIERS":
            return {
                ...state,
                project: {
                    ...state.project,
                    suppliers: [...state.project.suppliers, ...action.suppliers]
                }
            };
        case "IMPORT_ACCESSCONTROLS":
            return {
                ...state,
                project: {
                    ...state.project,
                    accesscontrols: [...state.project.accesscontrols, ...action.accesscontrols]
                }
            };
        case "IMPORT_ASSETS":
            return {
                ...state,
                project: {
                    ...state.project,
                    assets: [...state.project.assets, ...action.assets]
                }
            };
        case "IMPORT_CHARTACCOUNTS":
            return {
                ...state,
                project: {
                    ...state.project,
                    incomegroups: [...state.project.incomegroups, ...action.incomegroups],
                    incomeaccounts: [...state.project.incomeaccounts, ...action.incomeaccounts],
                    expensegroups: [...state.project.expensegroups, ...action.expensegroups],
                    expenseaccounts: [...state.project.expenseaccounts, ...action.expenseaccounts]
                }
            };
        case "IMPORT_CURRENCIES":
            return {
                ...state,
                project: {
                    ...state.project,
                    currencies: [...state.project.currencies, ...action.currencies]
                }
            };
        case "IMPORT_TEMPLATES":
            return {
                ...state,
                project: {
                    ...state.project,
                    templates: [...state.project.templates, ...action.templates]
                }
            };
        case "IMPORT_CONTRACTS":
            return {
                ...state,
                project: {
                    ...state.project,
                    contracts: [...state.project.contracts, ...action.contracts]
                }
            };
        case "IMPORT_EMERGENCYNUMBERS":
            return {
                ...state,
                project: {
                    ...state.project,
                    emergencynumbers: [...state.project.emergencynumbers, ...action.emergencynumbers]
                }
            };
        case "IMPORT_USERS":
            return {
                ...state,
                project: {
                    ...state.project,
                    users: action.users
                }
            };
        case 'UPDATE_KEYVALUE':
            return {
                ...state,
                project: {
                    ...state.project,
                    [action.key]: action.value
                }
            };
        default:
            return state;
    }
}

export default reducer;